/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiPerson } from './InternalApiPerson';
import {
    InternalApiPersonFromJSON,
    InternalApiPersonFromJSONTyped,
    InternalApiPersonToJSON,
    InternalApiPersonToJSONTyped,
} from './InternalApiPerson';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';

/**
 * 
 * @export
 * @interface InternalApiCasePerson
 */
export interface InternalApiCasePerson {
    /**
     * 
     * @type {InternalApiPerson}
     * @memberof InternalApiCasePerson
     */
    person: InternalApiPerson;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiCasePerson
     */
    createdAt: Date;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiCasePerson
     */
    createdBy: InternalApiUserBasicDetails;
}

/**
 * Check if a given object implements the InternalApiCasePerson interface.
 */
export function instanceOfInternalApiCasePerson(value: object): value is InternalApiCasePerson {
    if (!('person' in value) || value['person'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    return true;
}

export function InternalApiCasePersonFromJSON(json: any): InternalApiCasePerson {
    return InternalApiCasePersonFromJSONTyped(json, false);
}

export function InternalApiCasePersonFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCasePerson {
    if (json == null) {
        return json;
    }
    return {
        
        'person': InternalApiPersonFromJSON(json['person']),
        'createdAt': (new Date(json['createdAt'])),
        'createdBy': InternalApiUserBasicDetailsFromJSON(json['createdBy']),
    };
}

export function InternalApiCasePersonToJSON(json: any): InternalApiCasePerson {
    return InternalApiCasePersonToJSONTyped(json, false);
}

export function InternalApiCasePersonToJSONTyped(value?: InternalApiCasePerson | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'person': InternalApiPersonToJSON(value['person']),
        'createdAt': value['createdAt'].toISOString(),
        'createdBy': InternalApiUserBasicDetailsToJSON(value['createdBy']),
    };
}

